import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { DetailsContainer, Footer, Title, Content, Body } from '../DefaultStyles/Shared';
import { Container } from '../DefaultStyles/Details';
import ShareDrawer from '../../components/ShareDrawer';
import VideoPlayer from '../../components/Video/Video';

import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import { setOverlayPartnerVisible } from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';
import { Placeholders } from '../../utils/fillDynamicText';

const Video = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content isVideoCard={true} isSingleAction={true}>
                <Title
                    isShortText={!isLongText(props.cardTitle, 28)}
                    isLongText={isLongText(props.cardTitle, 60)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    isVideoCard={true}
                    onClick={e => {
                        props.setOverlayPartnerVisible(true, e, false);
                    }}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer id="videoContainer" isVideoCard={true}>
                    <VideoPlayer
                        url={props.videoUrl}
                        autoplay={!props.isVideoFrontCard}
                        muted={props.isVideoFrontCard}
                        isLongText={isLongText(props.cardTitle, 35)}
                    />
                </DetailsContainer>
            </Content>
            <Footer>
                <ShareDrawer backgroundColor={'#fff'} />
            </Footer>
        </Body>
    </Container>
);

Video.propTypes = {
    cardTitle: PropTypes.string.isRequired,
    isVideoFrontCard: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    videoUrl: PropTypes.string
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.localRepresentativeState,
                  state.localRep.localRepData.representative
              )
            : [];

        return {
            cardTitle: state.widget.cards[state.widget.activeAction.order - 1].heading
                .replace(/@articleUrl/g, state.widget.articleUrl)
                .replace(
                    new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                    state.localRep.localRepData.representative !== undefined
                        ? state.localRep.localRepData.postalCode
                        : ''
                )
                .replace(
                    new RegExp(
                        state.widget.activeAction.type === 'tweet'
                            ? Placeholders.TwitterMentionPlaceholder
                            : Placeholders.LocalRepresentative,
                        'g'
                    ),
                    state.localRep.localRepData.representative !== undefined
                        ? joinEnglish(
                              reps.map(
                                  rep =>
                                      `${rep.shortName} (${
                                          rep.level === 2
                                              ? rep.partyIdentifier +
                                                '-' +
                                                state.localRep.localRepData.state
                                              : state.localRep.localRepData.state +
                                                '-' +
                                                state.localRep.localRepData.district
                                      })`
                              )
                          )
                        : `Speakable`
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    state.localRep.localRepData.representative !== undefined
                        ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                        : '@Speakable'
                ),
            videoUrl:
                state.widget.activeAction.type === 'video'
                    ? state.widget.activeAction.url
                    : null,
            isVideoFrontCard:
                state.widget.cards[state.widget.activeAction.order - 1].order.value ===
                    1 && state.widget.activeAction.type === 'video'
        };
    },
    {
        setOverlayPartnerVisible
    }
)(Video);



// WEBPACK FOOTER //
// ./src/containers/Video/VideoDetails.jsx